module.exports = __webpack_public_path__ + "img/ibc-international-bio-cosmetics-social-media-slide-1.3687f1bb.jpg";